import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { colors,} from "@material-ui/core";
import { useTranslation } from "react-i18next";


export function TotalsInvSearch({ data,infoData }) {
  const cls = useRptAF();

  const styleE = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    padding: 2,
    fontSize: "0.8rem",
    fontWeight: "bold",
  };
  const styleTo = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: "bold",
  };
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}>
        <Grid container lg={12} md={12} className={cls.rootBdydown}>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={3} style={styleE}>
              {" عدد الفواتير "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" اجمالي المبلغ "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" اجمالي المدفوع "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" اجمالي المتبقي "}
            </Grid>
            <Grid item xs={3} style={styleE}>
              {" اجمالي السداد "}
            </Grid>
          </Grid>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={3} style={styleTo}>
              {data?.length}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {infoData.printKind == 1 ? data?.reduce((a, v) => (a = a + parseFloat(v.net_total)), 0).toFixed(2) : 
              parseFloat(infoData.tot?.netAmount).toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {infoData.printKind == 1 ? data?.reduce((a, v) => (a = a + parseFloat(v.paid)), 0).toFixed(2) : parseFloat(infoData.tot?.paid).toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {infoData.printKind == 1 ? data?.reduce((a, v) => (a = a + parseFloat(v.agel_part)), 0).toFixed(2) : parseFloat(infoData.tot?.agel).toFixed(2)}
            </Grid>
            <Grid item xs={3} style={styleTo}>
              {infoData.printKind == 1 ? data?.reduce((a, v) => (a = a + parseFloat(v.Sum_pay)), 0).toFixed(2) : parseFloat(infoData.tot?.sadad).toFixed(2)}
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function Body({ data, infoData, isLast }) {
  const { t } = useTranslation(["forms", "translation"]);

  var columns = [
    { title: "الرقم", field: "id" },
    {
      title: "التاريخ", field: "date",
      render: (expense) => reFormatDate(expense.date)
    },
    { title: "العميل", field: "customer_name" },
    { title: "نوع الفاتورة", field: "invTypes" },
    { title: "المبلغ", field: "net_total" },
    { title: "المدفوع", field: "paid" },
    { title: "المتبقي", field: "agel_part" },
    { title: "السداد", field: "Sum_pay" },

  ];


  const columns2 = [
    { title: "الرقم", field: "id" },
    {
      title: "التايخ", key: "date",
      render: (expense) => reFormatDate(expense.date)
    },
    { title: "النوع", field: "invKind" },
    { title: infoData.isPurches ? "المورد" : "العميل", field: "cust_name" },
    { title: "المبلغ", field: "netAmount" },
    { title: "المدفوع", field: "paid" },
    { title: "المتبقي", field: "agel_part" },
    { title: "السداد", field: "AllocatedPayment" },
    { title: " الحالة", field: "status" },

  ];
  const newData2 = data.map((row, i) => {
    return {
      ...row,
      paid: parseFloat(row.paid)?.toFixed(2),
      agel_part: parseFloat(row?.agel_part).toFixed(2),
      netAmount: parseFloat(row?.netAmount).toFixed(2),
      AllocatedPayment: parseFloat(row?.AllocatedPayment).toFixed(2),
    };
  });


  const newData = data.map((row, i) => {
    return {
      ...row,
      paid: (parseFloat(row.cash_part) + parseFloat(row.network_part) + parseFloat(row.bank_part))?.toFixed(2),
      agel_part: parseFloat(row?.agel_part).toFixed(2),
      Sum_pay: parseFloat(row?.Sum_pay).toFixed(2),
      inv_type: row.inv_type == 1 ? "اجل" : "نقدي",
    };
  });


  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}

        >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,

                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },

            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={infoData.printKind == 1 ? columns : columns2}
            data={infoData.printKind == 1 ? newData : newData2}
          />
          {/* {isLast && <TotalsInvSearch data={infoData.printKind == 1 ? newData ?? [] : newData2 ?? []} infoData={infoData}/>} */}
        </Grid>
      </Grid>


    </Grid>
  );
}

export default Body;
